/**
 * Plugin will help you automatically trigger standard event when specified DOM element gets into the user view (ie. end
 * of your content). Usage:
 *
 * Licensed under the MIT License.
 * Homepage: http://jquery.novoj.net/triggerOnView/index.html
 *
 * @version 1.0 (4. 6. 2011)
 * @author Jan Novotny (http://blog.novoj.net)
 */
define(['jquery'], function($){

	$.fn.triggerOnView = function(options) {

		var settings = {
			debug           : false,
			eventType       : 'click',
			verticalRange   : 0,
			horizontalRange : 0,
			singleShotOnly  : true,
			triggerStrategy : 'whole',
			callback        : null,
			triggerStrategies: {
				'whole': function(element) {
					var offset = element.offset();
					var $window = $(window);
					return $window.scrollTop() + $window.height() >= offset.top + element.height() + settings.verticalRange &&
							$window.scrollTop() <= offset.top - settings.verticalRange &&
							$window.scrollLeft() + $window.width() >= offset.left + element.width() + settings.horizontalRange &&
							$window.scrollLeft() <= offset.left - settings.horizontalRange
				},
				'part': function(element) {
					var offset = element.offset();
					var $window = $(window);
					return $window.scrollTop() + $window.height() >= offset.top + settings.verticalRange &&
							$window.scrollTop() <= offset.top + element.height() - settings.verticalRange &&
							$window.scrollLeft() + $window.width() >= offset.left + settings.horizontalRange &&
							$window.scrollLeft() <= offset.left + element.width() - settings.horizontalRange
				}
			}
		};

		return this.each(function() {

			var $this = $(this);

			if(options) {
				$.extend(settings, options);
			}

			var triggerOnView = function() {
				var $window = $(window);
				//compute whether the element is entirely visible to the user
				var doTrigger = settings.triggerStrategies[settings.triggerStrategy]($this);
				//this section is for debugging purposes only
				if(settings.debug) {
					var $monitor = $('#monitor');
					var offset = $this.offset();
					var debugContent = "<b>Offset top:</b> " + offset.top + "<br><b>ScrollTop:</b> " + $window.scrollTop() +
							"<br><b>Offset left:</b> " + offset.left + "<br><b>ScrollLeft:</b> " + $window.scrollLeft() +
							"<br><b>ScrollTop + Window:</b> " + ($window.scrollTop() + $window.height()) +
							"<br><b>ScrollLeft + Window:</b> " + ($window.scrollLeft() + $window.width()) +
							"<br><b>Will trigger:</b> " + doTrigger;
					if($monitor.length == 0) {
						$(document.body).append("<div id='monitor' style='position: absolute; top: 10px; left: 10px; padding: 1em; color: white; background-color: black'>" + debugContent + "</div>");
					} else {
						$monitor.css("top", window.pageYOffset + 10 + "px").html(debugContent);
					}
				}
				if(doTrigger) {
					//callback might stop trigerring process
					if ($.isFunction(settings.callback)) {
						if (settings.callback($this, settings) === false) {
							return false;
						}
					}
					$this.trigger(settings.eventType);
					//it's one shot function, so unregister itself
					if (settings.singleShotOnly) {
						$window.unbind("scroll", arguments.callee);
					}
					return true;
				} else {
					return false;
				}
			};

			//execute function immediately to check whether element is not already visible
			if (!triggerOnView.call(this)) {
				//bind function to window scroll event
				$(window).bind("scroll", triggerOnView);
			}

		});

	};
});


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.triggerOnView.js